import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  AfterViewInit,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core';
import { SpaceService } from '../../../services/space.service';
import _ from 'lodash';

@Component({
  selector: 'app-virtual-tours',
  templateUrl: './virtual-tours.component.html',
  styleUrls: ['./virtual-tours.component.scss'],
})
export class VirtualToursComponent
  implements OnInit, OnChanges, AfterViewInit, OnDestroy
{
  @Output() seletedMediaEmit = new EventEmitter<any>();
  @ViewChild('rendererContainer') rendererContainer: ElementRef;
  @Input() spaceData;

  // TEMP DATA
  CUBE_MESH_DATA = {
    images: {
      url: 'https://adminbetaspace.empatydev.net/uploads/spaces/f7e6d026-aa31-4a19-84b6-e832df8f5262/360/cubemap/',
      images: [
        '69a139cbc7895', // First Hotspot
        '69a139cec1c6a', // Second Hotspot
        '69a139d141683', // Third Hotspot
        '69a139d380088', // Fourth Hotspot
        '69a139d5b5de8', // Fifth Hotspot
      ],
    },
  };

  GLOBAL_POSES_DATA = [
    [
      0.008051, 0.999947, -0.006448, 0.002484, -0.999917, 0.008115, 0.009988,
      0.008156, 0.01004, 0.006368, 0.999929, 0.038815,
    ],
    [
      0.009908, -0.013102, 0.999865, -4.233805, -0.999471, 0.030829, 0.010308,
      0.059766, -0.03096, -0.999439, -0.01279, 0.418398,
    ],
    [
      0.029662, 0.023155, 0.999292, -4.09845, -0.999509, 0.010826, 0.029417,
      0.041501, -0.010137, -0.999673, 0.023464, -2.921355,
    ],
    [
      -0.033391, 0.113699, -0.992954, -0.690972, -0.999213, 0.017494, 0.035605,
      0.06741, 0.021419, 0.993361, 0.113025, -3.260374,
    ],
    [
      0.021138, 0.99908, 0.037304, -0.561869, -0.999198, 0.019842, 0.034787,
      0.10105, 0.034015, -0.03801, 0.998698, -6.220272,
    ],
  ];

  hotSpotsData: any;

  // Clicked events
  playIconClicked = false;

  // Three js components
  loading = true;
  isEmptyDollHouse = false;

  controls = null;
  title = null;
  renderer = null;
  scene = null;
  camera = null;
  mesh = null;
  ambientLight = null;
  pointLight = null;
  directionalLight1 = null;
  directionalLight2 = null;
  directionalLight3 = null;
  geometry = null;
  material = null;
  current360Image = null;

  threeDObject = null;

  cameraPosition: any;

  raycaster = new THREE.Raycaster();
  mouse = new THREE.Vector2(0, 0);
  mouseBox = null;
  hotspot = null;
  hotspotsMeshes: any[] = [];
  mediaData: any[] = [];

  // Inline panorama mode
  isInPanoramaMode = false;
  panoramaBox = null;
  panoramaHotspotMeshes: any[] = [];
  savedCameraPosition = null;
  savedControlsTarget = null;
  currentPanoramaIndex = -1;

  // Hardcoded cubemap base URLs — one per hotspot (keep in sync with drawHotspots positions)
  // cubemapBaseUrls: string[] = [
  //   "https://adminbetaspace.empatydev.net/uploads/spaces/8ff4dd87-3ee2-46fb-a34f-dbcfbf9688d3/360/cubemap/69957f804ce9c",
  //   "https://adminbetaspace.empatydev.net/uploads/spaces/8ff4dd87-3ee2-46fb-a34f-dbcfbf9688d3/360/cubemap/69957f83483e7",
  //   "https://adminbetaspace.empatydev.net/uploads/spaces/8ff4dd87-3ee2-46fb-a34f-dbcfbf9688d3/360/cubemap/69957f859c140",
  //   "https://adminbetaspace.empatydev.net/uploads/spaces/8ff4dd87-3ee2-46fb-a34f-dbcfbf9688d3/360/cubemap/69957f87c447a",
  //   "https://adminbetaspace.empatydev.net/uploads/spaces/8ff4dd87-3ee2-46fb-a34f-dbcfbf9688d3/360/cubemap/69957f8a06beb",
  //   "https://adminbetaspace.empatydev.net/uploads/spaces/8ff4dd87-3ee2-46fb-a34f-dbcfbf9688d3/360/cubemap/69957f8c46c2d",
  // ];

  // New Implementation
  cubemapBaseUrls: Array<string> = this.CUBE_MESH_DATA.images.images.map(
    (image) => `${this.CUBE_MESH_DATA.images.url}${image}`,
  );

  // Front-face direction vectors for each hotspot (3rd column of rotation matrix from poses.txt)
  // hotspotForwardVectors = [
  //   { x: -0.058373, y: -0.053412, z: 0.996865 }, // hotspot 0
  //   { x: -0.135414, y: -0.0012, z: -0.990788 }, // hotspot 1
  //   { x: 0.048067, y: 0.001573, z: 0.998843 }, // hotspot 2
  //   { x: -0.07921, y: 0.02447, z: -0.996558 }, // hotspot 3
  //   { x: -0.087244, y: 0.040334, z: -0.99537 }, // hotspot 4
  //   { x: -0.158564, y: 0.026445, z: -0.986995 }, // hotspot 5
  // ];

  // NEW-IMPLEMENTATION: Derive forward vectors from GLOBAL_POSES_DATA
  // 3rd column of rotation matrix: pose[2] = r02, pose[6] = r12, pose[10] = r22
  hotspotForwardVectors = this.GLOBAL_POSES_DATA.map((pose) => ({
    x: pose[2],
    y: pose[6],
    z: pose[10],
  }));

  // Camera Y heights from poses.txt (ty = column 8 of the 3×4 matrix)
  hotspotCameraHeights = [
    -0.272776, // hotspot 0
    0.159673, // hotspot 1
    0.134579, // hotspot 2
    0.131045, // hotspot 3
    0.203894, // hotspot 4
    0.215447, // hotspot 5
  ];

  manualControl = false;

  CANVAS_HEIGHT = 850;
  CANVAS_WIDTH = 1200;

  CANVAS_CENTER_X = 0;
  CANVAS_CENTER_Y = 0;

  initialCameraPosition = { x: 2, y: 9, z: -15 };

  objLoader = null;
  mtlLoader = null;

  guiParams = {
    position: {
      x: 0,
      y: 0,
      z: 0,
    },
    rotation: {
      x: 0,
      y: 0,
      z: 0,
    },
    proportion: {
      x: 1,
      y: 1,
      z: 1,
    },
    dollhouse: {
      enable: true,
      opacity: 0,
    },
    virtualTours: {
      enable: false,
    },
    image: {
      opacity: 0,
    },
  };

  squareBox: any;
  INTERSECTED = null;
  isDollhouseEnabled = false;

  constructor(private spaceService: SpaceService) {
    this.scene = new THREE.Scene();
    THREE.Object3D.DefaultUp.set(0.0, 1.0, 0.0);
    this.renderer = new THREE.WebGLRenderer({ antialias: true });

    this.objLoader = new THREE.OBJLoader();
    this.mtlLoader = new THREE.MTLLoader();
    this.mtlLoader.setCrossOrigin('*');
  }

  ngOnInit() {
    this.spaceService.spaceMediaDataSubscription.subscribe((response: any) => {
      this.mediaData = response ? response : [];
    });
  }

  ngAfterViewInit() {
    this.init();
    this.initMouseBox();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.spaceData.currentValue) {
      this.hotSpotsData = changes.spaceData.currentValue.hotspots
        ? changes.spaceData.currentValue.hotspots
        : [];
    }
  }

  onMouseMove(event) {
    if (this.threeDObject && this.threeDObject.children) {
      this.manualControl = true;
      const canvasBounds = this.renderer.context.canvas.getBoundingClientRect();
      this.mouse.x =
        ((event.clientX - canvasBounds.left) /
          (canvasBounds.right - canvasBounds.left)) *
          2 -
        1;
      this.mouse.y =
        -(
          (event.clientY - canvasBounds.top) /
          (canvasBounds.bottom - canvasBounds.top)
        ) *
          2 +
        1;
      this.raycaster.setFromCamera(this.mouse, this.camera);

      // Cursor change for panorama hotspot markers
      if (this.isInPanoramaMode && this.panoramaHotspotMeshes.length > 0) {
        const hits = this.raycaster.intersectObjects(
          this.panoramaHotspotMeshes,
          true,
        );
        this.rendererContainer.nativeElement.style.cursor =
          hits.length > 0 ? 'pointer' : 'default';
      }

      const intersects = this.raycaster.intersectObjects(
        this.threeDObject.children,
        true,
      );
      if (intersects[0]) {
        this.mouseBox.position.set(0, 0, 0);
        this.mouseBox.lookAt(intersects[0].face.normal);
        this.mouseBox.position.copy(intersects[0].point);
      }
    }
  }

  onMouseDown(event) {
    this.manualControl = false;
  }

  onMouseUp(event) {
    if (event.target.nodeName === 'CANVAS' && this.threeDObject) {
      this.raycaster.setFromCamera(this.mouse, this.camera);

      // ── In panorama mode: check for hotspot clicks (original dollhouse hotspots) ──
      if (this.isInPanoramaMode) {
        const hotspotHits = this.raycaster.intersectObjects(
          this.hotspotsMeshes,
          true,
        );
        if (hotspotHits.length > 0) {
          const hit = hotspotHits[0].object;
          const targetIndex = Number(hit.name.split('_')[1]);
          const baseUrl = this.cubemapBaseUrls[targetIndex];
          if (baseUrl !== undefined) {
            const cubemapUrls = [
              `${baseUrl}/R.jpg`,
              `${baseUrl}/L.jpg`,
              `${baseUrl}/U.jpg`,
              `${baseUrl}/D.jpg`,
              `${baseUrl}/B.jpg`,
              `${baseUrl}/F.jpg`,
            ];
            this.enterPanorama(hit.position, cubemapUrls, targetIndex);
          }
          return;
        }
        return; // In panorama mode — ignore other scene clicks
      }

      // ── Dollhouse mode: check for original hotspot clicks ──
      const hotspotIntersects = this.raycaster.intersectObjects(
        this.hotspotsMeshes,
        true,
      );

      if (hotspotIntersects.length > 0) {
        const clickedHotspot = hotspotIntersects[0].object;
        const name = clickedHotspot.name;
        const index = Number(name.split('_')[1]);
        const baseUrl = this.cubemapBaseUrls[index];
        console.log(name, index, baseUrl);

        if (!baseUrl) {
          console.warn(`No cubemap found for hotspot index ${index}`);
          return;
        }

        const cubemapUrls = [
          `${baseUrl}/R.jpg`,
          `${baseUrl}/L.jpg`,
          `${baseUrl}/U.jpg`,
          `${baseUrl}/D.jpg`,
          `${baseUrl}/B.jpg`,
          `${baseUrl}/F.jpg`,
        ];

        this.enterPanorama(clickedHotspot.position, cubemapUrls, index);
        return;
      }

      const intersects = this.raycaster.intersectObjects(
        this.threeDObject.children,
        true,
      );
      if (intersects[0]) {
        if (this.manualControl === false && !this.isDollhouseEnabled) {
          // if (intersects[ 0 ].point) {
          //   this.INTERSECTED = intersects[0].point;
          //   let p;
          //   let shortDistance;
          //   let previousDistance;
          //   let nearHotspot;
          //   for ( p = 0; p < this.jsonData.length; p++) {
          //     const jsonObject = this.jsonData[p];
          //     const jsonIntersect = new THREE.Vector3(
          //       jsonObject.cameraPosition.x,
          //       jsonObject.cameraPosition.y,
          //       jsonObject.cameraPosition.z
          //     );
          //     shortDistance = this.INTERSECTED.distanceTo( jsonIntersect );
          //     if ( p === 0) {
          //       nearHotspot = jsonObject;
          //       previousDistance = shortDistance;
          //       continue;
          //     } else {
          //       if (shortDistance < previousDistance) {
          //         nearHotspot = jsonObject;
          //       }
          //       previousDistance = shortDistance;
          //     }
          //   }
          //   if (nearHotspot) {
          //     const newIndexFound = _.findIndex(this.sphereMesh, {name: nearHotspot.id });
          //     const newMesh = _.find(this.jsonData, {id: nearHotspot.id });
          //     if (this.isDollhouseEnabled && newMesh || this.viewFloorPlanEnabled) {
          //       this.selectedThumbsData = event;
          //       this.animateAndJumpImage(newMesh, newIndexFound);
          //       this.disableAttributes('none');
          //     } else {
          //       this.threeDObject.visible = true;
          //       this.disableAttributes('none');
          //       this.selectedThumbsData = event;
          //       this.hideSphereMesh();
          //       if (newIndexFound >= 0 && newMesh) {
          //         this.controls.minPolarAngle = 0 * Math.PI / 180;
          //         this.controls.maxPolarAngle = 140 * Math.PI / 180;
          //         this.controls.enabled = true;
          //         this.controls.update();
          //         this.animateAndJumpImage(newMesh, newIndexFound);
          //       }
          //     }
          //   }
          //   // var a = new THREE.Vector3( 0, 1, 0 );
          //   // //no arguments; will be initialised to (0, 0, 0)
          //   // var b = new THREE.Vector3( );
          //   // var d = a.distanceTo( b );
          // }
        }
        // tslint:disable-next-line:max-line-length
        // tslint:disable-next-line:max-line-length
        //   const diffVec = new THREE.Vector3(this.controls.target.x, this.controls.target.y, this.controls.target.z).sub(this.camera.position);
        //   let i;
        //   for (i = 0; i < intersects.length; i++) {
        //     if (parseInt(intersects[i].object.name, 2) >= 0 &&  parseInt(intersects[i].object.name, 2) <= 6 ) {
        //       const clickedHotspot = intersects[i].object;
        //       const newTarget = new THREE.Vector3(intersects[i].object.position.x, intersects[i].object.position.y, 1.65);
        //       this.sphereMesh[parseInt(this.currentHotspot, 2)].visible = false;
        //       this.threeDObject.visible = true;
        //       const newcameraPos = new THREE.Vector3(newTarget.x, newTarget.y, newTarget.z).sub(diffVec);
        //       const tweenCamera = new TWEEN.Tween(this.camera.position).to(newcameraPos, 1000);
        //       const tweenTarget = new TWEEN.Tween(this.controls.target).to(newTarget, 1000);
        //       tweenCamera.onComplete(() => {
        //         this.threeDObject.visible = false;
        //         this.currentHotspot = clickedHotspot.name;
        //         this.sphereMesh[parseInt(this.currentHotspot, 2)].visible = true;
        //       });
        //       tweenCamera.easing(TWEEN.Easing.Cubic.Out);
        //       tweenCamera.start();
        //       tweenTarget.easing(TWEEN.Easing.Cubic.Out);
        //       tweenTarget.start();
        //     }
        //   }
        // }
        if (this.manualControl === false && this.isDollhouseEnabled) {
          if (this.threeDObject && this.threeDObject.children) {
            if (this.squareBox) {
              this.INTERSECTED = intersects[0].point;
              this.animateAndJumpThroughDollHouse(intersects[0].object);
            }
          }
        }
      } else {
        // if ( INTERSECTED ) INTERSECTED.material.emissive.setHex( INTERSECTED.currentHex );
        this.INTERSECTED = null;
      }
    }
  }

  init() {
    this.CANVAS_WIDTH = Math.round(
      parseFloat(getComputedStyle(this.rendererContainer.nativeElement).width),
    );
    this.CANVAS_HEIGHT = Math.round(
      parseFloat(getComputedStyle(this.rendererContainer.nativeElement).height),
    );
    this.CANVAS_CENTER_X = this.CANVAS_WIDTH / 2;
    this.CANVAS_CENTER_Y = this.CANVAS_HEIGHT / 2;

    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(this.CANVAS_WIDTH, this.CANVAS_HEIGHT);
    this.renderer.setClearColor(0xeeeeee, 1);

    this.rendererContainer.nativeElement.appendChild(this.renderer.domElement);

    this.camera = new THREE.PerspectiveCamera(
      75,
      this.CANVAS_WIDTH / this.CANVAS_HEIGHT,
      0.1,
      1000,
    );
    this.camera.position.set(
      this.initialCameraPosition.x,
      this.initialCameraPosition.y,
      this.initialCameraPosition.z,
    );
    // controls
    this.controls = new THREE.OrbitControls(
      this.camera,
      this.renderer.domElement,
    );
    this.controls.enableDamping = true; // an animation loop is required when either damping or auto-rotation are enabled
    this.controls.dampingFactor = 0.25;
    // Enable screen space panning so upward drag moves along Y axis (matches DefaultUp = (0, 1, 0))
    // this.controls.screenSpacePanning = true;
    // Invert rotation to match mouse dragging direction
    this.controls.rotateSpeed = -1.0;

    // scene - Soft ambient lighting only
    this.ambientLight = new THREE.AmbientLight(0xffffff, 0.8);
    this.scene.add(this.ambientLight);

    this.scene.add(this.camera);

    // create OrbitControls
    // this.controls = new THREE.OrbitControls(this.camera, this.rendererContainer.nativeElement);

    this.initDollHouse();
    // model
    this.animate();
  }

  // Helper to show axis and camera axis
  addHelper() {
    const helper = new THREE.CameraHelper(this.camera);
    this.scene.add(helper);
    const axesHelper = new THREE.AxesHelper(5);
    this.scene.add(axesHelper);
  }

  // 3d models house / object
  initDollHouse() {
    // Target will be set to mesh center after loading
    this.controls.minPolarAngle = (0 * Math.PI) / 180;
    this.controls.maxPolarAngle = (120 * Math.PI) / 180;
    this.controls.update();

    if (
      this.spaceData &&
      this.spaceData.media &&
      this.spaceData.media.mtl &&
      this.spaceData.media.mtl.base_url
    ) {
      // Create a LoadingManager to coordinate loading
      const loadingManager = new THREE.LoadingManager();

      // Create TextureLoader with the loading manager and set crossOrigin
      const textureLoader = new THREE.TextureLoader(loadingManager);
      textureLoader.setCrossOrigin('*');

      // Create MTLLoader with the loading manager
      const mtlLoader = new THREE.MTLLoader(loadingManager);
      mtlLoader.setCrossOrigin('*');

      // const mtlBaseUrl = this.spaceData.media.mtl.base_url.substring(0, this.spaceData.media.mtl.base_url.lastIndexOf('/') + 1);
      const mtlBaseUrl = this.spaceData.media.mtl.base_url.endsWith('/')
        ? this.spaceData.media.mtl.base_url
        : this.spaceData.media.mtl.base_url + '/';
      mtlLoader.setResourcePath(mtlBaseUrl);

      mtlLoader.load(
        `${this.spaceData.media.mtl.full_url}`,
        (materials) => {
          // Ensure materials has the manager set
          materials.setManager(loadingManager);
          // Ensure crossOrigin is set on materials
          materials.setCrossOrigin('*');

          // Override loadTexture method to use our configured TextureLoader
          const originalLoadTexture = materials.loadTexture.bind(materials);
          materials.loadTexture = function (
            url,
            mapping,
            onLoad,
            onProgress,
            onError,
          ) {
            const texture = textureLoader.load(
              url,
              onLoad,
              onProgress,
              onError,
            );
            if (mapping !== undefined) texture.mapping = mapping;
            return texture;
          };

          materials.preload();
          new THREE.OBJLoader(loadingManager).setMaterials(materials).load(
            `${this.spaceData.media.obj.full_url}`,
            (object) => {
              this.threeDObject = object;
              this.isDollhouseEnabled = true;
              this.loading = false;
              this.scene.add(object);

              // Calculate mesh center and set controls target to center
              const box = new THREE.Box3().setFromObject(object);
              const center = new THREE.Vector3();
              box.getCenter(center);
              this.controls.target.copy(center);
              this.controls.update();

              this.drawHotspots(center, box.min.y);
            },
            undefined,
            (error) => {
              console.error('Error loading OBJ file:', error);
              this.loading = false;
              this.isEmptyDollHouse = true;
            },
          );
        },
        undefined,
        (error) => {
          console.error('Error loading MTL file:', error);
          this.loading = false;
          this.isEmptyDollHouse = true;
        },
      );
    } else {
      this.loading = false;
      this.isEmptyDollHouse = true;
    }
  }

  loadSquare() {
    // const sphereGeometry = new THREE.SphereGeometry(1, 32 , 32);
    // const sphereMaterial = new THREE.MeshBasicMaterial({
    //   map: THREE.ImageUtils.loadTexture( 'assets/images/2d/1.jpg' ),
    //   transparent : true,
    //   opacity: 0.6,
    //   side: THREE.DoubleSide
    // });
    // this.squareBox = new THREE.Mesh( sphereGeometry, sphereMaterial );
    // this.squareBox.position.set(this.guiParams.position.x, this.guiParams.position.y, 1);
    // const mat = new THREE.Matrix4().identity();
    // mat.multiply(new THREE.Matrix4().makeTranslation(this.guiParams.position.x, this.guiParams.position.y, this.guiParams.position.z));
    // mat.multiply(new THREE.Matrix4().makeScale(-1, 1, 1));
    // this.squareBox.applyMatrix(mat);
    // this.squareBox.visible = true;
    // this.scene.add(this.squareBox);

    // this.camera.position.set(this.squareBox.position.x - 0.01,
    //   this.squareBox.position.y - 0.01,
    //   this.squareBox.position.z
    // );
    // this.camera.updateProjectionMatrix();
    // const tweenCamera = new TWEEN.Tween(this.camera.position).to({x: this.squareBox.position.x - 0.01,
    //   y: this.squareBox.position.y - 0.01,
    //   z: this.squareBox.position.z}, 1000);
    // const tweenTarget = new TWEEN.Tween(this.controls.target).to(this.squareBox.position, 1000);
    // tweenCamera.onUpdate(() => {
    //   if (this.controls.enabled === true) {
    //     this.controls.enabled = false;
    //   }
    // });
    // tweenCamera.onComplete(() => {
    //   this.controls.enabled = true;
    // });
    // tweenCamera.easing(TWEEN.Easing.Cubic.Out);
    // tweenCamera.start();
    // tweenTarget.easing(TWEEN.Easing.Cubic.Out);
    // tweenTarget.start();

    // const sphereMesh = new THREE.Mesh( sphere, sphereMaterial );

    const geometry = new THREE.BoxGeometry(1, 1, 1);

    const materialArray = [];
    materialArray.push(
      new THREE.MeshBasicMaterial({
        map: THREE.ImageUtils.loadTexture('assets/images/2d/face-r.jpg'),
        transparent: true,
        opacity: 0.6,
        side: THREE.DoubleSide,
      }),
    );
    materialArray.push(
      new THREE.MeshBasicMaterial({
        map: THREE.ImageUtils.loadTexture('assets/images/2d/face-t.jpg'),
        transparent: true,
        opacity: 0.6,
        side: THREE.DoubleSide,
      }),
    );
    materialArray.push(
      new THREE.MeshBasicMaterial({
        map: THREE.ImageUtils.loadTexture('assets/images/2d/face-d.jpg'),
        transparent: true,
        opacity: 0.6,
        side: THREE.DoubleSide,
      }),
    );
    materialArray.push(
      new THREE.MeshBasicMaterial({
        map: THREE.ImageUtils.loadTexture('assets/images/2d/face-f.jpg'),
        transparent: true,
        opacity: 0.6,
        side: THREE.DoubleSide,
      }),
    );
    materialArray.push(
      new THREE.MeshBasicMaterial({
        map: THREE.ImageUtils.loadTexture('assets/images/2d/face-b.jpg'),
        transparent: true,
        opacity: 0.6,
        side: THREE.DoubleSide,
      }),
    );
    materialArray.push(
      new THREE.MeshBasicMaterial({
        map: THREE.ImageUtils.loadTexture('assets/images/2d/face-l.jpg'),
        transparent: true,
        opacity: 0.6,
        side: THREE.DoubleSide,
      }),
    );

    const material = new THREE.MeshFaceMaterial(materialArray);

    this.squareBox = new THREE.Mesh(geometry, material);
    this.squareBox.position.set(0, 0, 2);
    this.squareBox.visible = true;
    this.scene.add(this.squareBox);

    // this.camera.position.set( this.squareBox.position.x, this.squareBox.position.y, this.squareBox.position.z );
    // this.camera.updateProjectionMatrix();
  }

  animateAndJump(newMesh) {
    const tweenCamera = new TWEEN.Tween(this.camera.position).to(
      {
        x: newMesh.position.x - 0.01,
        y: newMesh.position.y - 0.01,
        z: newMesh.position.z - 0.01,
      },
      1000,
    );
    const tweenTarget = new TWEEN.Tween(this.controls.target).to(
      newMesh.position,
      1000,
    );
    tweenCamera.onUpdate(() => {
      if (this.controls.enabled === true) {
        this.controls.enabled = false;
      }
    });
    tweenCamera.onComplete(() => {
      this.controls.enabled = true;
      this.threeDObject.visible = false;
    });
    tweenCamera.easing(TWEEN.Easing.Cubic.Out);
    tweenCamera.start();
    tweenTarget.easing(TWEEN.Easing.Cubic.Out);
    tweenTarget.start();
  }

  // Enter panorama mode: create cubemap box at hotspot position, animate camera inside
  enterPanorama(
    hotspotPosition: any,
    cubemapUrls: string[],
    hotspotIndex: number = -1,
  ) {
    this.currentPanoramaIndex = hotspotIndex;

    // Store reference to old panorama box for transition
    const oldPanoramaBox = this.isInPanoramaMode ? this.panoramaBox : null;

    if (!this.isInPanoramaMode) {
      // First entry from dollhouse — save camera state for returning
      this.savedCameraPosition = {
        x: this.camera.position.x,
        y: this.camera.position.y,
        z: this.camera.position.z,
      };
      this.savedControlsTarget = {
        x: this.controls.target.x,
        y: this.controls.target.y,
        z: this.controls.target.z,
      };
    }

    // Get pose forward direction
    const forward = this.hotspotForwardVectors[hotspotIndex] || {
      x: 0,
      y: 0,
      z: 1,
    };
    const cameraY =
      this.hotspotCameraHeights[hotspotIndex] != null
        ? this.hotspotCameraHeights[hotspotIndex]
        : hotspotPosition.y + 0.001;
    const yRotation = Math.atan2(forward.x, forward.z);

    // Pre-build the NEW panorama box (hidden until tween completes)
    const geometry = new THREE.BoxGeometry(500, 500, 500);
    const loader = new THREE.TextureLoader();
    loader.setCrossOrigin('anonymous');

    const materialArray = cubemapUrls.map((url) => {
      const texture = loader.load(url);
      texture.generateMipmaps = false;
      texture.wrapS = texture.wrapT = THREE.ClampToEdgeWrapping;
      texture.minFilter = THREE.LinearFilter;
      return new THREE.MeshBasicMaterial({
        map: texture,
        side: THREE.DoubleSide,
        transparent: false,
        depthWrite: false,
      });
    });

    this.panoramaBox = new THREE.Mesh(geometry, materialArray);
    this.panoramaBox.position.set(
      hotspotPosition.x,
      cameraY, // Center box at pose camera height
      hotspotPosition.z,
    );
    this.panoramaBox.rotation.y = yRotation;
    this.panoramaBox.name = 'panoramaBox';
    this.panoramaBox.visible = false;
    this.scene.add(this.panoramaBox);

    // For panorama-to-panorama: show 3D model during fly
    if (oldPanoramaBox) {
      if (this.threeDObject) {
        this.threeDObject.visible = true;
      }
      const oldMats = Array.isArray(oldPanoramaBox.material)
        ? oldPanoramaBox.material
        : [oldPanoramaBox.material];
      oldMats.forEach((m) => {
        m.transparent = true;
      });

      const fadeOut = { t: 1 };
      const tweenFadeOut = new TWEEN.Tween(fadeOut).to({ t: 0 }, 400);
      tweenFadeOut.onUpdate(() => {
        oldMats.forEach((m) => (m.opacity = fadeOut.t));
      });
      tweenFadeOut.onComplete(() => {
        this.scene.remove(oldPanoramaBox);
      });
      tweenFadeOut.easing(TWEEN.Easing.Cubic.Out);
      tweenFadeOut.start();
    }

    // Fly camera to hotspot at pose height
    const tweenCamera = new TWEEN.Tween(this.camera.position).to(
      {
        x: hotspotPosition.x,
        y: cameraY,
        z: hotspotPosition.z,
      },
      1200,
    );

    // Determine look direction
    let lookDir;
    if (oldPanoramaBox) {
      lookDir = {
        x: this.controls.target.x - this.camera.position.x,
        y: this.controls.target.y - this.camera.position.y,
        z: this.controls.target.z - this.camera.position.z,
      };
    } else {
      lookDir = forward;
    }

    const tweenTarget = new TWEEN.Tween(this.controls.target).to(
      {
        x: hotspotPosition.x + lookDir.x,
        y: cameraY + lookDir.y,
        z: hotspotPosition.z + lookDir.z,
      },
      1200,
    );

    tweenCamera.onUpdate(() => {
      if (this.controls.enabled === true) {
        this.controls.enabled = false;
      }
    });

    tweenCamera.onComplete(() => {
      if (this.threeDObject) {
        this.threeDObject.visible = false;
      }
      this.hotspotsMeshes.forEach((m, i) => {
        console.log('tween camera complete', i, this.currentPanoramaIndex, m);
        m.visible = i !== this.currentPanoramaIndex;
      });
      if (this.mouseBox) {
        this.mouseBox.visible = false;
      }
      if (this.squareBox) {
        this.squareBox.visible = false;
      }

      this.panoramaBox.visible = true;

      // Lock camera — rotate in place
      const camPos = this.camera.position;
      this.controls.target.set(camPos.x, camPos.y, camPos.z);
      this.controls.minDistance = 0;
      this.controls.maxDistance = 0.001;
      this.controls.enabled = true;
      this.controls.enableZoom = false;
      this.controls.enablePan = false;
      this.isInPanoramaMode = true;

      // Crossfade for panorama-to-panorama
      if (oldPanoramaBox) {
        const newMats = Array.isArray(this.panoramaBox.material)
          ? this.panoramaBox.material
          : [this.panoramaBox.material];
        newMats.forEach((m) => {
          m.transparent = true;
          m.opacity = 0;
        });

        const fadeIn = { t: 0 };
        const tweenFadeIn = new TWEEN.Tween(fadeIn).to({ t: 1 }, 400);
        tweenFadeIn.onUpdate(() => {
          newMats.forEach((m) => (m.opacity = fadeIn.t));
        });
        tweenFadeIn.onComplete(() => {
          newMats.forEach((m) => {
            m.transparent = false;
            m.opacity = 1;
          });
        });
        tweenFadeIn.easing(TWEEN.Easing.Cubic.InOut);
        tweenFadeIn.start();
      }
    });

    tweenCamera.easing(TWEEN.Easing.Cubic.InOut);
    tweenCamera.start();
    tweenTarget.easing(TWEEN.Easing.Cubic.InOut);
    tweenTarget.start();
  }

  // Spawn navigation hotspot markers inside the panorama
  spawnPanoramaHotspots(currentPosition: any) {
    // Clean up any previous markers
    this.panoramaHotspotMeshes.forEach((m) => {
      if (m.parent) {
        m.parent.remove(m);
      } else {
        this.scene.remove(m);
      }
    });
    this.panoramaHotspotMeshes = [];

    if (!this.panoramaBox) {
      return;
    }

    const markerGeometry = new THREE.TorusBufferGeometry(8, 3, 16, 32);
    const markerMaterial = new THREE.MeshBasicMaterial({
      color: 0x00ffff,
      transparent: true,
      opacity: 0.8,
      side: THREE.DoubleSide,
    });

    // Hotspot world positions (same as drawHotspots)
    // const positions = [
    //   { x: -0.039264, z: 0.433823 },
    //   { x: 0.574565, z: 3.881326 },
    //   { x: 4.369175, z: 0.079923 },
    //   { x: 4.55413, z: 3.844705 },
    //   { x: 7.321181, z: 3.79662 },
    //   { x: 8.981576, z: 2.613807 },
    // ];

    // NEW-IMPLEMENTATION: Derive positions from GLOBAL_POSES_DATA (tx = pose[3], tz = pose[11])
    const positions = this.GLOBAL_POSES_DATA.map((pose) => ({
      x: pose[3],
      z: pose[11],
    }));
    // THESE POSITIONS ARE NOT BEING CALLED!

    // Scale factor: dollhouse spans ~9 units, box is 500 units wide (±250 from center)
    // Scale offsets so they fill the box proportionally
    const scale = 25;

    positions.forEach((targetPos, index) => {
      if (index === this.currentPanoramaIndex) {
        return; // Skip self
      }

      // Offset from current hotspot (in dollhouse world units), scaled to panorama box
      const dx = (targetPos.x - currentPosition.x) * scale;
      const dz = (targetPos.z - currentPosition.z) * scale;

      // Place marker at the scaled dollhouse offset, on the floor
      const marker = new THREE.Mesh(markerGeometry, markerMaterial.clone());
      marker.position.set(
        dx,
        0, // Floor level inside the 500×500×500 box
        dz,
      );
      marker.rotation.x = -Math.PI / 2; // Flat on floor

      marker.name = `pano_hotspot_${index}`;
      marker.userData = { cubemapIndex: index };

      // Add as child of panoramaBox so it's inside the cubemap
      this.panoramaBox.add(marker);
      this.panoramaHotspotMeshes.push(marker);
    });
  }
  // Exit panorama mode: remove cubemap box, restore dollhouse
  exitPanorama() {
    if (!this.isInPanoramaMode) {
      return;
    }

    // Remove panorama box
    if (this.panoramaBox) {
      this.scene.remove(this.panoramaBox);
      this.panoramaBox = null;
    }

    // Show dollhouse and hotspots
    if (this.threeDObject) {
      this.threeDObject.visible = true;
    }
    this.hotspotsMeshes.forEach((m) => (m.visible = true));
    if (this.mouseBox) {
      this.mouseBox.visible = true;
    }

    // Animate camera back to saved position
    const tweenCamera = new TWEEN.Tween(this.camera.position).to(
      this.savedCameraPosition,
      1000,
    );
    const tweenTarget = new TWEEN.Tween(this.controls.target).to(
      this.savedControlsTarget,
      1000,
    );
    tweenCamera.onUpdate(() => {
      if (this.controls.enabled === true) {
        this.controls.enabled = false;
      }
    });
    tweenCamera.onComplete(() => {
      this.controls.enabled = true;
      this.controls.enableZoom = true;
      this.controls.enablePan = true;
      this.controls.minDistance = 0;
      this.controls.maxDistance = Infinity;
      this.isInPanoramaMode = false;
    });
    tweenCamera.easing(TWEEN.Easing.Cubic.Out);
    tweenCamera.start();
    tweenTarget.easing(TWEEN.Easing.Cubic.Out);
    tweenTarget.start();
  }

  // Mouse move circle
  initMouseBox() {
    const geometry = new THREE.TorusBufferGeometry(0.1, 0.01, 2, 150, 6.3);
    const material = new THREE.MeshBasicMaterial({
      color: 0x5fe6ff,
      transparent: true,
      opacity: 1.6,
    });
    this.mouseBox = new THREE.Mesh(geometry, material);
    this.mouseBox.name = 'mouseSprite';
    this.scene.add(this.mouseBox);
  }

  drawHotspots(center: any, floorLevel: number) {
    const geometry = new THREE.RingGeometry(0.15, 0.35, 32);
    const material = new THREE.MeshBasicMaterial({
      color: 0xcccccc,
      side: THREE.DoubleSide,
      polygonOffset: true,
      polygonOffsetFactor: -1,
      polygonOffsetUnits: -1,
      transparent: true,
      opacity: 0.4,
    });

    // const positions = [
    //   // { x: 0.07648820589688428, y: floorLevel, z: 0.028047671073859876 },
    //   // { x: 0.06746433440636898, y: floorLevel, z: -0.06780357390021356 },
    //   // { x: -0.1097350675999741 - 1, y: floorLevel, z: -0.1911349404753963 },
    //   // { x: center.x, y: floorLevel, z: center.z + 1 },
    //   // { x: center.x, y: floorLevel, z: center.z - 1 },
    //   { x: -0.039264, y: floorLevel + 0.001, z: 0.433823 },
    //   { x: 0.574565, y: floorLevel + 0.001, z: 3.881326 },
    //   { x: 4.369175, y: floorLevel + 0.001, z: 0.079923 },
    //   { x: 4.55413, y: floorLevel + 0.001, z: 3.844705 },
    //   { x: 7.321181, y: floorLevel + 0.001, z: 3.79662 },
    //   { x: 8.981576, y: floorLevel + 0.001, z: 2.613807 },
    // ];

    // NEW-IMPLEMENTATION: Derive positions from GLOBAL_POSES_DATA (tx = pose[3], tz = pose[11])
    const positions = this.GLOBAL_POSES_DATA.map((pose) => ({
      x: pose[3],
      y: floorLevel + 0.001,
      z: pose[11],
    }));

    positions.forEach((pos, index) => {
      const mesh = new THREE.Mesh(geometry, material);
      mesh.position.set(pos.x, pos.y, pos.z);
      mesh.rotation.x = -Math.PI / 2; // Lie on XZ plane
      mesh.name = `hotspot_${index}`;
      this.scene.add(mesh);
      this.hotspotsMeshes.push(mesh);
    });

    // DEBUG: show wireframe cubemap boxes at each hotspot position
    // const boxGeo = new THREE.BoxGeometry(1, 1, 1);
    // const wireframeMat = new THREE.MeshBasicMaterial({
    //   color: 0xff0000,
    //   wireframe: true,
    //   transparent: true,
    //   opacity: 0.3,
    // });
    // positions.forEach((pos) => {
    //   const debugBox = new THREE.Mesh(boxGeo, wireframeMat);
    //   debugBox.position.set(pos.x, pos.y, pos.z); // Y=0 to match current panoramaBox Y
    //   debugBox.name = "debug_cubemap_box";
    //   this.scene.add(debugBox);
    // });
  }

  onProgressObjectLoader(xhr) {}

  onErrorObjectLoader(xhr) {}

  animate() {
    requestAnimationFrame(this.animate.bind(this));
    if (this.controls) {
      this.controls.update();
    }

    // Pulse panorama hotspot markers
    if (this.isInPanoramaMode && this.panoramaHotspotMeshes.length > 0) {
      const pulse = 1 + 0.15 * Math.sin(Date.now() * 0.003);
      this.panoramaHotspotMeshes.forEach((m) => {
        m.scale.set(pulse, pulse, pulse);
      });
    }

    TWEEN.update();
    this.render();
  }

  render() {
    if (this.renderer) {
      this.renderer.render(this.scene, this.camera);
    }
  }

  resizeHandler(event) {
    this.CANVAS_WIDTH = Math.round(
      parseFloat(getComputedStyle(this.rendererContainer.nativeElement).width),
    );
    this.CANVAS_HEIGHT = Math.round(
      parseFloat(getComputedStyle(this.rendererContainer.nativeElement).height),
    );

    this.camera.aspect = this.CANVAS_WIDTH / this.CANVAS_HEIGHT;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize(this.CANVAS_WIDTH, this.CANVAS_HEIGHT);
  }

  playVirtualTours() {
    this.playIconClicked = true;
    // this.animateAndJump(this.squareBox);
    // this.initialAnimateJumpImage();
    // this.animateAndJumpImage();
  }

  initialAnimateJumpImage() {
    if (this.hotSpotsData && this.hotSpotsData.length > 0) {
    } else {
      this.animateAndJumpThroughDollHouse({
        position: { x: 0, y: -0.3, z: 1.65 },
      });
    }
  }

  animateAndJumpThroughDollHouse(meshobject) {
    if (this.threeDObject && this.threeDObject.children) {
      const tweenCamera = new TWEEN.Tween(this.camera.position).to(
        { x: 0, y: -0.3, z: 1.65 },
        3000,
      );
      const tweenTarget = new TWEEN.Tween(this.controls.target).to(
        { x: 0, y: 0, z: 1.65 },
        3000,
      );
      tweenCamera.onUpdate(() => {
        if (this.controls.enabled === true) {
          this.controls.enabled = false;
        }
      });
      tweenCamera.onComplete(() => {
        this.controls.enabled = true;
        this.squareBox.visible = true;
      });
      tweenCamera.easing(TWEEN.Easing.Cubic.Out);
      tweenCamera.start();
      tweenTarget.easing(TWEEN.Easing.Cubic.Out);
      tweenTarget.start();
    }
  }

  animateAndJumpImage(meshobject) {
    const tweenCamera = new TWEEN.Tween(this.camera.position).to(
      {
        x: meshobject.position.x - 0.01,
        y: meshobject.position.y - 0.01,
        z: meshobject.position.z,
      },
      1000,
    );
    const tweenTarget = new TWEEN.Tween(this.controls.target).to(
      meshobject.position,
      1000,
    );
    tweenCamera.onUpdate(() => {
      if (this.controls.enabled === true) {
        this.controls.enabled = false;
      }
    });
    tweenCamera.onComplete(() => {
      this.controls.enabled = true;
      meshobject.visible = true;
    });
    tweenCamera.easing(TWEEN.Easing.Cubic.Out);
    tweenCamera.start();
    tweenTarget.easing(TWEEN.Easing.Cubic.Out);
    tweenTarget.start();
  }

  ngOnDestroy() {
    let i;

    for (i = this.scene.children.length - 1; i >= 0; i--) {
      const obj = this.scene.children[i];
      this.scene.remove(obj);
    }
    this.threeDObject = null;
    this.scene = null;
    this.camera = null;
    this.renderer = null;

    this.controls = null;
    this.mesh = null;
    this.ambientLight = null;
    this.pointLight = null;
    this.directionalLight1 = null;
    this.directionalLight2 = null;
    this.directionalLight3 = null;
    this.geometry = null;
    this.material = null;
    this.cameraPosition = undefined;

    if (this.rendererContainer) {
      this.rendererContainer.nativeElement.remove();
    }
  }

  checkKeyboard(e) {
    const re =
      /\d|\w|[\.\$@\*\\\/\+\-\^\!\(\)\[\]\~\%\&\=\?\>\<\{\}\"\'\,\:\;\_]/g;
    const a = e.key.match(re);
    if (a == null) {
      return false;
    }
    return true;
  }

  setupDatGUI() {
    // dat.gui
    const gui = new dat.GUI();

    const position = gui.addFolder('Position');
    position
      .add(this.guiParams.position, 'x', -4, 4)
      .step(0.001)
      .onChange((value) => {
        this.squareBox.position.x = value;
        this.camera.position.set(
          this.squareBox.position.x,
          this.squareBox.position.y,
          this.squareBox.position.z,
        );
        this.camera.updateProjectionMatrix();
      });
    position
      .add(this.guiParams.position, 'y', -4, 4)
      .step(0.001)
      .onChange((value) => {
        this.squareBox.position.y = value;
        this.camera.position.set(
          this.squareBox.position.x,
          this.squareBox.position.y,
          this.squareBox.position.z,
        );
        this.camera.updateProjectionMatrix();
      });
    position
      .add(this.guiParams.position, 'z', -4, 4)
      .step(0.001)
      .onChange((value) => {
        this.squareBox.position.z = value;
        this.camera.position.set(
          this.squareBox.position.x,
          this.squareBox.position.y,
          this.squareBox.position.z,
        );
        this.camera.updateProjectionMatrix();
      });

    const orientation = gui.addFolder('Orientation');
    orientation
      .add(this.guiParams.rotation, 'x', -360, 360)
      .step(0.000001)
      .onChange((value) => {
        this.squareBox.rotation.x = (value * Math.PI) / 180;
      });
    orientation
      .add(this.guiParams.rotation, 'y', -360, 360)
      .step(0.000001)
      .onChange((value) => {
        this.squareBox.rotation.y = (value * Math.PI) / 180;
      });
    orientation
      .add(this.guiParams.rotation, 'z', -360, 360)
      .step(0.000001)
      .onChange((value) => {
        this.squareBox.rotation.z = (value * Math.PI) / 180;
      });

    const proportion = gui.addFolder('Height / Width');
    proportion
      .add(this.guiParams.proportion, 'x', 0, 30)
      .step(1)
      .onChange((value) => {
        this.squareBox.scale.x = value;
      });
    proportion
      .add(this.guiParams.proportion, 'y', 0, 30)
      .step(1)
      .onChange((value) => {
        this.squareBox.scale.y = value;
      });

    proportion
      .add(this.guiParams.proportion, 'z', 0, 30)
      .step(1)
      .onChange((value) => {
        this.squareBox.scale.z = value;
      });

    if (this.squareBox) {
      const thisobject = this;
      const imageUi = gui.addFolder('Image');
      imageUi
        .add(this.guiParams.image, 'opacity', -4, 4)
        .step(0.0001)
        .onChange((value) => {
          // let i ;
          // for (i = 0; i < thisobject.squareBox.material.length; i++) {
          thisobject.squareBox.material.transparent = true;
          thisobject.squareBox.material.opacity = value;
          // }
        });
    }

    const dollhouse = gui.addFolder('Dollhouse');
    dollhouse
      .add(this.guiParams.dollhouse, 'enable', true)
      .onChange((value) => {
        this.threeDObject.visible = value;
      });

    dollhouse
      .add(this.guiParams.dollhouse, 'opacity', -4, 4)
      .step(0.0001)
      .onChange((value) => {
        this.threeDObject.traverse((child) => {
          if (child instanceof THREE.Mesh) {
            child.material.opacity = value;
            child.material.transparent = true;
          }
        });
      });

    const virtualTours = gui.addFolder('Virtual Tours');
    virtualTours
      .add(this.guiParams.virtualTours, 'enable', false)
      .onChange((value) => {
        let i;
        for (i = 0; i < this.squareBox.material.length; i++) {
          this.squareBox.material[i].opacity = 1;
        }
        this.animateAndJump(this.squareBox);
        this.threeDObject.visible = false;
      });
  }
}
